import type { Alert, WatchlistScope } from "./types";

/** A page filter over saved scopes; `null` leaves that dimension unfiltered. */
export type ScopeFilter = {
  userIds: string[] | null;
  processSlugs: string[] | null;
};

/**
 * Whether a saved scope watches any of the filtered people and processes. An
 * alert over every process watches whichever process is picked, so it stays
 * listed under any process filter.
 */
export const scopeOverlaps = (scope: WatchlistScope, filter: ScopeFilter): boolean => {
  const { userIds, processSlugs } = filter;
  if (userIds && !scope.userIds.some(id => userIds.includes(id))) return false;
  if (!processSlugs) return true;
  if (scope.processSlugs.length === 0)
    return scope.allProcesses !== false && processSlugs.length > 0;
  return scope.processSlugs.some(slug => processSlugs.includes(slug));
};

const standing = (alert: Alert): number => (alert.unread ? 0 : alert.enabled ? 1 : 2);
const lastActivity = (alert: Alert): number =>
  Date.parse(alert.runs[0]?.ranAt ?? alert.createdAt) || 0;

/** Unread results first, paused alerts last, most recently run first within each. */
export const compareAlerts = (a: Alert, b: Alert): number =>
  standing(a) - standing(b) || lastActivity(b) - lastActivity(a);
